import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  constructor() {}

  /**
   * Send Google Analytics Page View event
   * @param page - send page view to google analytics
   */
  public sendPageView(page: string): void {
    if (window['ga']) {
      (window as any).ga('set', 'page', page);
      (window as any).ga('send', 'pageview');
    }

    if (window['ac']) {
      (window as any).ac('pageview');
    }
  }

  /**
   * Send Google Event
   * @param category - a category string
   * @param action - action string
   * @param label - label string
   */
  public sendEvent(category: string, action: string, label: string): void {
    if (window['ga']) {
      (window as any).ga('send', 'event', category, action, label);
    }
  }
}
